import { axiosCashJournalClient } from "../api";
import { MIDDLE_URL } from "../config";
import {
  IPostBusinessPayload,
  IGetBusinessResponse,
  IPostBusinessResponse,
  IGetBusinessesPayload,
  IGetBusinessesResponse,
  IPutBusinessPayload,
} from "./types";

export const url = "/v1/smplmstbusiness";

export const getBusinesses = async (
  payload: IGetBusinessesPayload,
): Promise<IGetBusinessesResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
    params: payload,
  });

  return data;
};

export const getBusinessById = async (
  id: string,
): Promise<IGetBusinessResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/id/${id}`,
    method: "GET",
  });

  return data;
};

export const postBusiness = async (
  payload: IPostBusinessPayload,
): Promise<IPostBusinessResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "POST",
    data: payload,
  });

  return data;
};

export const putBusiness = async (
  payload: IPutBusinessPayload,
): Promise<IPostBusinessResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "PUT",
    data: payload,
  });

  return data;
};

export const deleteBusiness = async (
  id: number,
): Promise<IPostBusinessResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${id}`,
    method: "DELETE",
  });

  return data;
};

export const getBusinessSegment = async (
  codeType: string,
  areaId: string,
  poolId: string,
): Promise<IGetBusinessResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/codetype/${codeType}/areaid/${areaId}/pool_id/${poolId}`,
    method: "GET",
  });

  return data;
};

export const getBusinessCompany = async (
  codeType: string,
  areaId: string,
  poolId: string,
  codeSegment: string,
): Promise<IGetBusinessResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/codetype/${codeType}/areaid/${areaId}/pool_id/${poolId}/codesegment/${codeSegment}`,
    method: "GET",
  });

  return data;
};

export const getBusinessCompanyRelation = async (
  codeType: string,
  areaId: string,
  poolId: string,
  codeSegment: string,
  companyCode: string,
): Promise<IGetBusinessResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/codetype/${codeType}/areaid/${areaId}/pool_id/${poolId}/codesegment/${codeSegment}/companycode/${companyCode}`,
    method: "GET",
  });

  return data;
};
